import { cn } from "@devhop/ui";
import type { Category } from "../../domain/types";

type CategoryTabsProps = {
  categories: Category[];
  selectedCategoryId: string | null;
  onSelectCategory: (categoryId: string | null) => void;
  isLoading?: boolean;
};

export function CategoryTabs({
  categories,
  selectedCategoryId,
  onSelectCategory,
  isLoading = false,
}: CategoryTabsProps) {
  return (
    <div className="-mx-1 flex gap-2 overflow-x-auto px-1 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <button
        type="button"
        onClick={() => onSelectCategory(null)}
        disabled={isLoading}
        className={cn(
          "h-10 shrink-0 whitespace-nowrap rounded-full border px-4 font-medium text-sm transition-colors disabled:opacity-50",
          selectedCategoryId === null
            ? "border-primary bg-primary text-primary-foreground"
            : "border-border bg-card text-foreground hover:bg-accent hover:text-accent-foreground",
        )}
      >
        ທັ້ງຫມດ
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          type="button"
          onClick={() => onSelectCategory(category.id)}
          disabled={isLoading}
          className={cn(
            "h-10 shrink-0 whitespace-nowrap rounded-full border px-4 font-medium text-sm transition-colors disabled:opacity-50",
            selectedCategoryId === category.id
              ? "border-primary bg-primary text-primary-foreground"
              : "border-border bg-card text-foreground hover:bg-accent hover:text-accent-foreground",
          )}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
}
